export default __webpack_public_path__ + "static/media/NHPLogo.484618fb.png";